export default Object.freeze({
  STATUS_PENDING: 'pending',
  STATUS_IN_PROGRESS: 'inProgress',
  STATUS_READY: 'ready',
  STATUS_FAILED: 'failed'
})
